import { CSSProperties, Fragment, ReactElement } from "react";
import TableContainer from "../../../../components/tableContainer";
import { IReportTreeNode, TreeStructure } from "../types";
import { Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow } from "@mui/material";
import { IParentSize } from "../../../../types";

interface IProps {
  hidden: boolean;
  data: Record<string, number>[];
  parentSize: IParentSize;
}


interface IRowComponentProps {
  node: IReportTreeNode;
  level: number;
  data: Record<string, number>[];
}

const headerStyle: CSSProperties = {
  fontWeight: "bold",
  width: 300,
  maxWidth: 300,
  color: "#3c3c3c",
  background: "#c3c3c3",
  padding: ".5em",
  borderLeft: "1px solid rgba(81, 81, 81, 1)",
  borderBottom: 0
};

const valueStyle: CSSProperties = {
  fontWeight: "bold",
  width: 100,
  maxWidth: 100,
  color: "#3c3c3c",
  background: "#f3f3f3",
  padding: ".5em",
  margin: .5
};

const RowComponent = ({ node, level, data }: IRowComponentProps): ReactElement => {

  return (
    <>
      {node.children && node.children.map((n, i) => {
        const titleStyle: CSSProperties = {
          ...headerStyle,
          background: n.palette?.background ?? "#c3c3c3",
          paddingLeft: `${level + .5}em`,
          visibility: level === -1 ? "hidden" : undefined,
        };

        const unitStyle: CSSProperties = {
          ...headerStyle,
          background: n.palette?.background ?? "#c3c3c3",
          visibility: level === -1 ? "hidden" : undefined,
          width: 80,
          maxWidth: 80,
          textAlign: "center",
          position: "sticky",
          borderRight: "1px solid rgba(81, 81, 81, 1)"
        };

        return (
          <Fragment key={`n-${level}-${i}`}>
            <TableRow>

              <TableCell style={{ position: "sticky", left: 0, padding: 0 }}>
                <div className="display-flex-row">
                  <div style={titleStyle}><strong>{n.title}</strong></div>
                  <div style={unitStyle}>{n.unit}</div>
                </div>
              </TableCell>
              {data.map((d, j) => {

                return (
                  <TableCell key={`n-${level}-${i}-${j}`} style={{
                    ...valueStyle,
                    background: n.palette?.background ?? "#f3f3f3",
                    textAlign: n.align ?? "right",
                    borderLeft: j === 0 ? 0 : "1px solid rgba(81, 81, 81, 1)"
                  }}>
                    {d[n.field ?? n.title] ?? "---"}
                  </TableCell>
                );
              })}
              <TableCell style={{ background: n.palette?.background ?? "#f3f3f3", borderLeft: "1px solid rgba(81, 81, 81, 1)" }} />
            </TableRow>
            <RowComponent node={n} level={level + 1} data={data} />
          </Fragment>
        );
      })}
    </>
  );
};

const TableComponent = ({ hidden, data, parentSize }: IProps): ReactElement => {

  return (
    <TableContainer hidden={hidden} style={{ height: parentSize.height, maxHeight: parentSize.height }}>
      <Table stickyHeader={true}  size={"small"}>
        <TableHead>
          <TableRow>
            <TableCell style={{ width: 380, minWidth: 380, zIndex: 999, borderRight: "1px solid rgba(81, 81, 81, 1)",
              borderLeft: "1px solid rgba(81, 81, 81, 1)", position: "sticky", left: 0, backgroundColor: "#b0bec5", }}>
              {/*<TableCell sx={{ width: 300, minWidth: 300 }} />*/}
              {/*<TableCell sx={{ width: 80, minWidth: 80 }}/>*/}
            </TableCell>
            {data.map((column, index) =>
              <TableCell
                  style={{ backgroundColor: "#b0bec5", width: 100, minWidth: 100, borderLeft: index === 0 ? 0 : "1px solid rgba(81, 81, 81, 1)" }}
                key={`col-${column.reference}`}
                align="center">
                {column.reference}
              </TableCell>
            )}
            <TableCell style={{ backgroundColor: "#b0bec5", borderLeft: "1px solid rgba(81, 81, 81, 1)" }} />
          </TableRow>
        </TableHead>
        <TableBody>
          <RowComponent node={TreeStructure} level={0} data={data} />
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableComponent;